import type { AdminAnnouncementEmailTemplateDefinition } from "./types";
import {
    formatListBlock,
    joinBlocks,
    splitLines,
} from "./utils";

export const safetyAlertTemplate: AdminAnnouncementEmailTemplateDefinition = {
    key: "SAFETY_ALERT",
    label: "Safety Alert",
    description:
        "A high-clarity layout for urgent safety messaging and protective guidance.",
    recommendedAnnouncementType: "SAFETY_WARNING",
    messageLabel: "Alert Details *",
    messagePlaceholder:
        "Describe the situation clearly, what users should know, and the seriousness of the update.",
    previewEyebrow: "Safety Alert",
    previewHeaderClassName:
        "bg-[linear-gradient(135deg,#dc2626_0%,#ef4444_45%,#7f1d1d_100%)]",
    previewBadgeClassName:
        "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300",
    fields: [
        {
            id: "incidentArea",
            label: "Area or Context",
            type: "text",
            placeholder: "Lekki Phase 1",
        },
        {
            id: "recommendedActions",
            label: "Recommended Actions",
            type: "textarea",
            placeholder: "One action per line",
            required: true,
            rows: 4,
        },
        {
            id: "supportContact",
            label: "Support Contact",
            type: "text",
            placeholder: "support@ride2five.com",
        },
    ],
    buildBody: ({ message, fields }) =>
        joinBlocks([
            fields.incidentArea?.trim()
                ? `We’re issuing a safety alert for ${fields.incidentArea.trim()}.`
                : "We’re issuing a safety alert.",
            message,
            fields.recommendedActions
                ? formatListBlock("Recommended actions", fields.recommendedActions)
                : null,
            fields.supportContact?.trim()
                ? `Support contact: ${fields.supportContact.trim()}`
                : null,
        ]),
    buildPreviewSections: ({ message, fields }) => [
        ...(fields.incidentArea?.trim()
            ? [
                  {
                      label: "Affected Area",
                      body: fields.incidentArea.trim(),
                      tone: "accent" as const,
                  },
              ]
            : []),
        {
            label: "Alert",
            body: message,
            tone: "default",
        },
        ...(splitLines(fields.recommendedActions || "").length > 0
            ? [
                  {
                      label: "Recommended Actions",
                      body: splitLines(fields.recommendedActions || "").join("\n"),
                      tone: "accent" as const,
                      list: true,
                  },
              ]
            : []),
        ...(fields.supportContact?.trim()
            ? [
                  {
                      label: "Support Contact",
                      body: fields.supportContact.trim(),
                      tone: "muted" as const,
                  },
              ]
            : []),
    ],
};
